const caseBg = document.querySelectorAll('.cases__wrapper');

const isTablet = () => {
    return window.matchMedia('(max-width: 1024px)').matches
}
const isMobile = () => {
    return window.matchMedia('(max-width: 768px)').matches
}

function updateBackgroundImages() {
    let windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

    caseBg.forEach(function (container) {
        let desktopImage = container.getAttribute('data-desktop-image');
        let tabletImage = container.getAttribute('data-tablet-image');
        let mobileImage = container.getAttribute('data-mobile-image');

        if (windowWidth > 1024) {
            container.style.backgroundImage = 'url(' + desktopImage + ')';
        } else if (windowWidth <= 1024 && windowWidth > 768) {
            container.style.backgroundImage = isTablet() ? 'url(' + tabletImage + ')' : 'none';
        } else {
            container.style.backgroundImage = isMobile() ? 'url(' + mobileImage + ')' : 'none';
        }
    });
}

updateBackgroundImages();
window.addEventListener('resize', updateBackgroundImages);